/** The set item form's per-group ceilings — the rules the add and edit forms share. */

export interface AddonSlot {
  option_id: string;
  slots: number;
}

export type AddonLimits = Record<string, {max_choice?: unknown}>;

/**
 * The groups a set uses, once each, with how many slots it gives them. The
 * ceiling is per GROUP, not per slot: a group listed twice is two slots but one
 * budget.
 */
export const addonGroupSlots = (addons: Array<{option_id?: string}> = []): AddonSlot[] => {
  const slots = new Map<string, number>();
  (addons || []).forEach((addon) => {
    const id = addon?.option_id;
    if (id) {
      slots.set(id, (slots.get(id) || 0) + 1);
    }
  });
  return [...slots.entries()].map(([option_id, count]) => ({ option_id, slots: count }));
};

/**
 * The ceilings for the groups this set still uses — what actually gets sent. A
 * dropped group leaves its cap behind in the form's map, and the backend stores
 * the map as given, so the dead key would outlive the group.
 */
export const usedAddonLimits = (values: {
  addons?: Array<{option_id?: string}>;
  addon_limits?: AddonLimits;
} = {}): AddonLimits => {
  const used = new Set(addonGroupSlots(values?.addons).map((group) => group.option_id));
  return Object.fromEntries(
    Object.entries(values?.addon_limits || {}).filter(([optionId]) => used.has(optionId))
  );
};
